import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PathwayButton } from './PathwayButton';
interface ConfirmModalProps {
  open: boolean;
  title: string;
  description: React.ReactNode;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Plain two-button confirmation for destructive actions in the builder.
 */
export function ConfirmModal({
  open,
  title,
  description,
  confirmLabel,
  onConfirm,
  onCancel
}: ConfirmModalProps) {
  return <AnimatePresence data-id="element-1526" data-mp="jdorbbidy3qx">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.16
    }} className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 p-4" role="dialog" aria-modal="true" aria-labelledby="confirm-title" data-id="element-1527" data-mp="jcndiz9zj35i">
          <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        y: 8
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full max-w-md rounded-xl bg-white p-6 shadow-lg" data-id="element-1528" data-mp="2u5q74meg9vvn">
            <h2 id="confirm-title" className="text-lg font-bold text-gray-900" data-id="element-1529" data-mp="26cxv09233ieo">
              {title}
            </h2>
            <p className="mt-2 text-sm text-gray-600" data-id="element-1530" data-mp="2b7buonns4bp5">{description}</p>

            <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-1531" data-mp="2f6azm89ig8gl">
              <PathwayButton variant="secondary" fullWidth onClick={onCancel} data-id="element-1532" data-mp="2k5e5fuxbeipm">
                Cancel
              </PathwayButton>
              <PathwayButton fullWidth onClick={onConfirm} data-id="element-1533" data-mp="2p6bkvzqxwynf">
                {confirmLabel}
              </PathwayButton>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}